// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"800":"bbad0434","919":"0c6f81bf"}[chunkId] + ".chunk.css";
};